'use client'

import { resolveClientSlicing } from '@/features/advanced-twap/lib/advanced-twap-format'
import {
  FormInput,
  FormSection,
} from '@/features/order/order-form/components/widget/order-form-fields'
import { TwapIntervalInput } from '@/features/order/order-form/components/widget/twap-interval-input'

interface AdvancedTwapDurationInputProps {
  durationSeconds: string
  onDurationChange: (value: string) => void
  totalSlices: string
  onTotalSlicesChange: (value: string) => void
}

/**
 * Duration + optional total-slices override, with a pre-submit preview of the resolved
 * slicing (contract §5's 10s-per-slice floor can silently reduce a requested count) —
 * surfaced here so the reduction is never a surprise at submit time.
 */
export function AdvancedTwapDurationInput({
  durationSeconds,
  onDurationChange,
  totalSlices,
  onTotalSlicesChange,
}: AdvancedTwapDurationInputProps) {
  const duration = parseInt(durationSeconds) || 0
  const requested = parseInt(totalSlices) || 10
  const preview = duration > 0 ? resolveClientSlicing(duration, requested) : null

  const handleSlicesInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    if (val === '' || /^\d*$/.test(val)) onTotalSlicesChange(val)
  }

  return (
    <div className="flex flex-col gap-4">
      <FormSection label="Duration">
        <TwapIntervalInput value={durationSeconds} onChange={onDurationChange} />
      </FormSection>
      <FormSection
        label="Total slices"
        hint={
          preview
            ? `Resolves to ${preview.totalSlices} slice${preview.totalSlices === 1 ? '' : 's'} of ${preview.sliceDurationS.toFixed(0)}s each — no slice can be shorter than 10s.`
            : 'Optional'
        }
      >
        <FormInput
          aria-label="Total slices"
          inputMode="numeric"
          value={totalSlices}
          onChange={handleSlicesInput}
          placeholder="10"
        />
      </FormSection>
    </div>
  )
}
